import { TextSmall } from '@/components/Texts';
import React from 'react';

const ChangesDataProtectionNotice = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (7) Changes to the data protection notice
      </TextSmall>
      <TextSmall>
        In the context of the further development of data protection law as well
        as technological or organizational changes, our data protection
        information is regularly reviewed to determine whether it needs to be
        adapted or supplemented. You will be informed of any changes in
        particular on our website at Diment.io. This data protection notice is
        valid as of 7st December 2023. Please check back frequently to see any
        updates or changes to our Privacy Statement.
      </TextSmall>
    </>
  );
};

export default ChangesDataProtectionNotice;
